import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import {
  ExternalUserInputDto,
  ExternalUserPreviewDto,
  ExternalUserSearchResultDto,
} from "../interfaces/admin/ExternalUser";
import { EnumNomenclature } from "../common/components/mui-extended/CheckboxSelectExtended";

const apiEndpoint = "/externalUser";

const getExternalUsersAsync = async (query: string): Promise<AxiosResponse<Array<ExternalUserSearchResultDto>>> => {
  return await http.get<Array<ExternalUserSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getExternalUsersCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getExternalUserAsync = async (id: number): Promise<AxiosResponse<ExternalUserPreviewDto>> => {
  return await http.get<ExternalUserPreviewDto>(`${apiEndpoint}/${id}`);
};

const addExternalUserAsync = async (model: ExternalUserInputDto): Promise<AxiosResponse<ExternalUserInputDto>> => {
  return await http.post<ExternalUserInputDto>(apiEndpoint, model);
};

const updateExternalUserAsync = async (model: ExternalUserInputDto): Promise<AxiosResponse<ExternalUserInputDto>> => {
  return await http.put<ExternalUserInputDto>(`${apiEndpoint}/${model.externalUserId}`, model);
};

const getExternalUserIdByUsernameAsync = async (username: string): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(`${apiEndpoint}/idByUsername?username=${username}`);
};

const getPermissionRegistersAsync = async (): Promise<AxiosResponse<Array<EnumNomenclature>>> => {
  return await http.get<Array<EnumNomenclature>>(`${apiEndpoint}/permissionRegisters`);
};

export default {
  getExternalUsersAsync,
  getExternalUsersCountAsync,
  getExternalUserAsync,
  addExternalUserAsync,
  updateExternalUserAsync,
  getExternalUserIdByUsernameAsync,
  getPermissionRegistersAsync,
};
